/**
 * Российский номер в E.164: +7 и 10 цифр (без пробелов).
 * Ввод: 8…, 7…, 10 цифр без префикса.
 */

export function normalizeRussianPhoneToE164(raw) {
    if (raw == null || typeof raw !== "string") return null;

    const digits = raw.replace(/\D/g, "");
    if (digits.length === 0) return null;

    if (digits.length === 11) {
        if (digits[0] === "8") {
            const rest = digits.slice(1);
            if (!/^\d{10}$/.test(rest)) return null;
            return "+7" + rest;
        }
        if (digits[0] === "7") {
            return "+7" + digits.slice(1);
        }
        return null;
    }

    if (digits.length === 10) {
        return "+7" + digits;
    }

    return null;
}

/** Из любого ввода извлекает до 10 цифр национальной части (после +7 / 8). */
export function parsePhoneInputToNationalDigits(raw) {
    if (raw == null || typeof raw !== "string") return "";
    let d = raw.replace(/\D/g, "");
    if (d.length === 0) return "";
    d = d.replace(/^0+/, "");

    if (d[0] === "7") {
        return d.slice(1, 11);
    }
    if (d[0] === "8") {
        return d.slice(1, 11);
    }
    return d.slice(0, 10);
}

/** Отображение в международном виде без пробелов: +79991234567 */
export function formatNationalAsE164Display(nationalDigits) {
    const n = (nationalDigits || "").replace(/\D/g, "").slice(0, 10);
    if (!n) return "+7";
    return "+7" + n;
}
